import Link from 'next/link'
import { createSlug } from 'utilities/blog'
import { Category } from '../../../types/blog-types'
import s from './styles.module.css'

interface CategoriesProps {
  categories?: [Category?]
  className?: string
}

export default function Categories({ categories, className }: CategoriesProps) {
  if (!categories) return null
  return (
    <div className={className || s.categories}>
      {categories.map(({ sys, fields }) => {
        const slug = createSlug(fields)
        return (
          <Link key={`link-${sys.id}`} href={slug} legacyBehavior>
            <label key={sys.id} className={s.label}>
              {fields.name}
            </label>
          </Link>
        )
      })}
    </div>
  )
}
